import { render, staticRenderFns } from "./ArchiveDesignModal.vue?vue&type=template&id=0581cf72"
import script from "./ArchiveDesignModal.vue?vue&type=script&lang=js"
export * from "./ArchiveDesignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports